// @ts-nocheck

import { KLCollectibleIds } from '../types/collectible';
import { KLRounds } from '../types/round';

export const KLRoundViewByOrder = [KLRounds.T_RED, KLRounds.T_WHITE, KLRounds.ORIENTATION, KLRounds.POLE];

export const KLRoundIndexByRoundId = new Proxy(
  {
    [KLRounds.T_RED]: KLRoundViewByOrder.indexOf(KLRounds.T_RED),
    [KLRounds.T_WHITE]: KLRoundViewByOrder.indexOf(KLRounds.T_WHITE),
    [KLRounds.ORIENTATION]: KLRoundViewByOrder.indexOf(KLRounds.ORIENTATION),
    [KLRounds.POLE]: KLRoundViewByOrder.indexOf(KLRounds.POLE),
  },
  {
    get(origin, key) {
      return origin[key] ?? -1;
    },
  },
);

export const KLRound3StepIdsByOrder = [KLCollectibleIds.MARK, KLCollectibleIds.TAG, KLCollectibleIds.KNIFE];
